import {
  APPLICATION_TVA_TYPE_EXPORT_HORS_UE,
  APPLICATION_TVA_TYPE_INTRACOMMUNAUTAIRE,
  APPLICATION_TVA_TYPE_NON_APPLICABLE,
} from '@/configuration/tiers/tiersConf';

export default function getExonerationTva(tiers) {
  if (!tiers?.applicationTva) return false;
  return [
    APPLICATION_TVA_TYPE_EXPORT_HORS_UE,
    APPLICATION_TVA_TYPE_INTRACOMMUNAUTAIRE,
    APPLICATION_TVA_TYPE_NON_APPLICABLE,
  ].includes(tiers.applicationTva);
}
